<template>
  <div class="layout1" style="background: #f4f6f8">
    <div class="intes-bt">报告对比</div>
    <div class="intes-ts">最多支持5份同类报告的对比</div>
    <div class="intes-bg">
      <div class="reprotComItem" v-for="(item, index) in list" :key="index">
        <van-col span="4" class="reprotCheck"
          ><van-checkbox
            v-model="item.active"
            icon-size="24px"
            @click="reprotCheck"
          ></van-checkbox
        ></van-col>
        <van-col span="20">
          <div class="reprotBox">
            <img :src="require(`@/assets/image/chang/小肠.png`)" />
            <div class="reprotText">
              <h3>{{ item.report_type }}</h3>
              <p>{{ item.updated_at }}</p>
            </div>
            <div class="reprotPf">
              <span>{{ item.marks }}</span
              >分
            </div>
          </div>
        </van-col>
      </div>
    </div>
    <div
      :class="btnStatus ? 'reportBtn disabled' : 'reportBtn'"
      @click="detail()"
    >
      对比
    </div>
    <ball :text="'返回'"></ball>
  </div>
</template>
<script>
import { Toast } from 'vant';
import ball from "./components/ball.vue"
import Report from "../../models/Report";
export default {
  components: { ball },
  data () {
    return {
      btnStatus: true,
      list: [
      ],
      test_report_id: []
    }
  },
  computed: {
    user_no () {
      return this.$route.query.user_no || "";
    },
  },
  created () {

    // if (this.list.length == 1) {
    //   Toast('您当前没有可对比的报告');
    // }
    this.getRecordlists()
  },
  methods: {
    detail () {

      this.$router.push({ path: '/contrast', query: { user_no: this.user_no, test_report_id: JSON.stringify(this.test_report_id) } });

    },
    reprotCheck () {
      this.test_report_id = []
      this.list.forEach((item) => {
        if (item.active) {
          this.test_report_id.push(item.id)
        }
      })
      let arr = []
      this.list.forEach((item) => {
        if (item.active) {
          arr.push(item.active)
        }
      })
      this.test_report_id.length >= 2 ? this.btnStatus = false : this.btnStatus = true
      if (arr.length > 5) {
        Toast({
          message: '最多支持5份同类报告的对比',
          className: 'tianlei',
        });
        this.btnStatus = true
      } else {

      }

    },
    getRecordlists () {
      let params = {
        user_no: this.user_no,
        keyword: '肠胃动力评估'
      };
      Report.getReportList({ ...params }, (res, err) => {
        Toast.loading({
          message: '加载中...',
          className: 'tianlei',
          forbidClick: true,
          duration: 0,
          loadingType: 'spinner',
        });
        if (!err) {
          console.log(res)
          res.data.forEach((item) => {
            item.active = false
          })
          this.list = res.data
          // this.list.splice(1, 1)
          if (this.list.length == 1) {
            Toast({
              message: '您当前没有可对比的报告',
              className: 'tianlei',
            });
          }
          setTimeout(() => {
            Toast.clear()
          }, 1500)


        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.intes-bt {
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
}
.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
.intes-bg {
  min-height: calc(100% - 300px);
  margin-top: 20px;
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  padding: 40px 0;
}

.reportBtn {
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 34px;
  text-align: center;
  background: #3094e6;
  color: #fff;
  font-weight: bold;
  margin-top: 10px;
}
.reprotComItem {
  display: flex;
  height: 160px;
  margin-bottom: 40px;

  .reprotBox {
    width: 94%;
    height: 160px;
    box-sizing: border-box;

    background: #ffffff;
    box-shadow: 0px 8px 21px 0px rgba(0, 73, 124, 0.1);
    padding: 0 37px;
    border-radius: 10px;
    .reprotText {
      float: left;
      h3 {
        font-size: 30px;
      }
      p {
        font-size: 26px;
      }
    }
    .reprotPf {
      float: right;
      width: 110px;
      height: 110px;
      line-height: 110px;
      background: #f4faff;
      border: 2px dashed #32c8ff;
      border-radius: 50%;
      text-align: center;
      margin-top: 20px;
      font-size: 30px;
      color: #3094e6;
      span {
        font-size: 50px;
        font-weight: bold;
      }
    }
    img {
      width: 40px;
      height: 49px;
      float: left;
      margin-right: 20px;
      margin-top: 50px;
    }
  }
  .reprotCheck {
    text-align: center;
    line-height: 160px;
    .van-checkbox {
      display: inline-block;
    }
  }
}
</style>